import { showConfirmDialog } from 'vant'
import router from '@/router'
import { useUserStore } from '@/store/user'


/**
 * 显示登录确认弹窗（用于401响应和request拦截器中的登录过期场景）
 * @param {string} type - 登录提示类型：
 *   - 'notLoggedIn': 未登录状态（默认）
 *   - 'functionNeedLogin': 功能需要登录
 *   - 'loginExpired': 登录已过期
 * @returns {Promise} - 确认后的Promise
 */
export const showLoginConfirm = (type = 'notLoggedIn') => {
  // 根据类型确定提示消息
  const messages = {
    notLoggedIn: '您当前未登录，是否跳转到登录页面？',
    functionNeedLogin: '该功能需要登录使用，现在去登录？',
    loginExpired: '当前登录失效，需要重新登录。'
  }

  // 确保type有效
  const message = messages[type] || messages.notLoggedIn;

  // 处理登录过期情况, 清空本地存储中的token等登录信息
  if (type === 'loginExpired') {
    const userStore = useUserStore()
    userStore.logout()
  }

  // 显示确认弹窗
  return showConfirmDialog({
    title: '系统提示',
    message: message,
    confirmButtonText: '去登录',
    cancelButtonText: '取消'
  }).then(() => {
    // 用户确认，跳转到登录页面（携带当前路径作为redirect）
    const userStore = useUserStore()
    const currentPath = router.currentRoute.value.fullPath
    userStore.logout()
    // 使用 window.location.href 强制页面刷新，确保组件正确渲染
    const loginUrl = `/login?redirect=${encodeURIComponent(currentPath)}&logout=1`
    window.location.href = loginUrl
    return Promise.resolve()
  }).catch(() => {
    // 用户取消
  })
}

/**
 * 显示通用确认弹窗
 * @param {Object} options - 弹窗配置
 * @param {string} options.title - 弹窗标题
 * @param {string} options.message - 弹窗内容
 * @param {string} [options.confirmButtonText='确定'] - 确认按钮文本
 * @param {string} [options.cancelButtonText='取消'] - 取消按钮文本
 * @returns {Promise} - 弹窗操作后的Promise
 */
export const showConfirm = (options) => {
  const defaultOptions = {
    title: '提示',
    message: '',
    confirmButtonText: '确定',
    cancelButtonText: '取消'
  }

  return showConfirmDialog({
    ...defaultOptions,
    ...options
  })
}